import React from 'react';
import { createForm } from 'rc-form';
import { Toast } from 'antd-mobile';
import QuestionnaireItem from './activity-qa-item';

import { queryQustionsInfo, queryAnswersByXfieldOrActId } from '../../service/api';

type ActivityQuestionsProps = {
    surveyActivityId: number;
    answerList?: any[];
    onRef: (e) => void;
} & Props;

class ActivityQuestions extends React.Component<ActivityQuestionsProps, State> {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            questionInfo: null,
            questionList: [],
        };
        if (props.onRef) {
            //如果父组件传来该方法 则调用方法将子组件this指针传过去
            props.onRef(this);
        }
    }

    componentWillMount() {
        this.getQuestinoList();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (JSON.stringify(this.props) === JSON.stringify(nextProps)) return;
        this.getQuestinoList();
    }

    formatAnswerObj = (answerList?: any[]) => {
        let obj = {};
        if (!answerList || !answerList.length) {
            return obj;
        }
        answerList.map(item => {
            let answer;
            try {
                answer = JSON.parse(item.answer);
            } catch (error) {
                answer = item.answer;
            }
            obj[item.question.name] = item.answerFlag ? answer : undefined;
        });

        return obj;
    };

    async getQuestinoList() {
        let { surveyActivityId } = this.props;
        let params = { activityId: surveyActivityId };
        let questionInfoRes = await queryQustionsInfo(params);
        const { status, result } = questionInfoRes;
        if (!status) {
            const { survey } = result;
            this.setState({
                loading: false,
                questionInfo: survey,
                questionList: survey.questionList,
            });
        } else {
            this.setState({
                loading: false,
            });
            Toast.show('获取问卷信息失败');
        }
    }

    getVerifyRoles = item => {
        let roles: any[] = [
            {
                required: item.requiredFlag,
                message: '该选项为必填',
            },
        ];
        if (item.bizTypeName === '手机号码') {
            roles.push({
                pattern: new RegExp(/^(1[3-9][0-9])[0-9]{8}$/),
                message: '请输入正确的手机号',
            });
        }
        if (item.bizTypeName === '邮箱') {
            roles.push({
                pattern: new RegExp(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/),
                message: '请输入正确的邮箱',
            });
        }
        if (item.bizTypeName === '微信号码') {
            roles.push({
                pattern: new RegExp(/^[a-zA-Z]([-_a-zA-Z0-9]{5,20})$/),
                message: '请输入正确的微信号码',
            });
        }

        return roles;
    };

    handleValidate = () => {
        return new Promise((resolve, reject) => {
            this.props.form.validateFields((error: any, values: any) => {
                if (!error) {
                    this.setState({
                        submitLoading: true,
                    });
                    let answerList: any[] = [];
                    let answerValue = values;
                    for (let i in answerValue) {
                        answerList.push({
                            questionName: i,
                            answer: answerValue[i],
                        });
                    }
                    let params = {
                        surveyName: this.state.questionInfo?.name,
                        questionAnswerList: answerList,
                        userName: answerValue['姓名'],
                    };
                    resolve(params);
                } else {
                    reject('请先完成问卷');
                }
            });
        });
    };

    render() {
        const { getFieldProps, getFieldError } = this.props.form;
        let { questionList } = this.state;
        const answersObj = this.formatAnswerObj(this.props.answerList);

        return (
            <div className="activity-qa-list">
                {questionList.map((item, index) => (
                    <QuestionnaireItem
                        key={index}
                        name={item.name}
                        required={!!item.requiredFlag}
                        question={item}
                        {...getFieldProps(item.name, {
                            initialValue: answersObj[item.name],
                            rules: this.getVerifyRoles(item),
                        })}
                        error={getFieldError(item.name)}
                    />
                ))}
            </div>
        );
    }
}

export default createForm()(ActivityQuestions);
